/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Opacity_LabelInputs */



/**
* | output |
* | --- |
* | "Opacity" |
*
* @param {Video_Export_Opacity_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_opacity_label = /** @type {((inputs?: Video_Export_Opacity_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Opacity_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opacite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Opazität")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opacità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Непрозрачность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opacidad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不透明度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("不透明度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अस्पष्टता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opacidade")
	return /** @type {LocalizedString} */ ("Opacity")
});